/**
 * Calls the given function asynchronously once (as a new micro task).
 * In most cases, this is a better alternative to using setTImeout(fn, 0).
 */
export const async = ( func: () => any ) => {
    Promise.resolve( null ).then( func as any );
};
